import * as React from "react"

const IconConfirm = (props) => (
  <svg
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 11a2.222 2.222 0 1 0-2.222-2.222M11 14.333h.011M21 11c0 5.523-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1s10 4.477 10 10Z"
      stroke="#1B1464"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconConfirm
